import type {FlexSection} from '../../../schemas/contentful/contentTypes/flexSection'
import {Grid, Section, Stack} from '@primer/react-brand'
import {ContentfulSectionIntro} from '../ContentfulSectionIntro/ContentfulSectionIntro'
import {ContentfulPillars} from '../ContentfulPillars/ContentfulPillars'
import {ContentfulFeaturedBento} from '../ContentfulFeaturedBento/ContentfulFeaturedBento'
import {ContentfulIntroStackedItems} from '../ContentfulIntroStackedItems/ContentfulIntroStackedItems'
import styles from './ContentfulFlexSection.module.css'
import {ContentfulCards} from '../ContentfulCards/ContentfulCards'

export type ContentfulFlexSectionProps = {
  component: FlexSection
  className?: string
}

export function ContentfulFlexSection({component, className}: ContentfulFlexSectionProps) {
  const {id, introStackedItems, sectionIntro, pillars, cards, featuredBento, visualSettings} = component.fields
  const {
    backgroundColor = 'default',
    paddingBlockStart = 'spacious',
    paddingBlockEnd = 'spacious',
    roundedCorners = false,
    verticalGap = 'normal',
    backgroundImage,
    backgroundImagePosition,
    backgroundImageSize,
  } = visualSettings?.fields ?? {}

  return (
    <Section
      className={`${className ? `${className} ` : ''}${styles.section}`}
      backgroundColor={backgroundColor}
      backgroundImageSrc={backgroundImage?.fields.file.url}
      backgroundImagePosition={backgroundImagePosition}
      backgroundImageSize={backgroundImageSize}
      paddingBlockStart={paddingBlockStart}
      paddingBlockEnd={paddingBlockEnd}
      rounded={roundedCorners}
      id={id}
    >
      <Stack padding="none" gap={verticalGap} direction="vertical">
        {introStackedItems && (
          <ContentfulIntroStackedItems className={styles.normalizeMargin} component={introStackedItems} />
        )}

        {sectionIntro && (
          <Grid className={styles.sectionIntro}>
            <Grid.Column>
              <ContentfulSectionIntro className={styles.normalizePadding} component={sectionIntro} />
            </Grid.Column>
          </Grid>
        )}

        {pillars && <ContentfulPillars className={`${styles.normalizeMargin} ${styles.pillars}`} component={pillars} />}

        {cards && <ContentfulCards className={styles.normalizeMargin} component={cards} fullWidth />}

        {featuredBento && (
          <Grid className={styles.normalizeMargin}>
            <Grid.Column>
              <ContentfulFeaturedBento
                itemBgColor={backgroundColor === 'default' ? 'subtle' : 'default'}
                className={styles.normalizePadding}
                component={featuredBento}
              />
            </Grid.Column>
          </Grid>
        )}
      </Stack>
    </Section>
  )
}

try{ ContentfulFlexSection.displayName ||= 'ContentfulFlexSection' } catch {}